<template class="pageUser">
    <b-modal centered
             class="custom modul"
             ref="confrimCancelModal"
             :title="$t('Potwierdź operację')">
        <template slot="modal-header">
            <h5 class="modal-title">{{$t('Czy na pewno chcesz anulować?')}}</h5>
            <button type="button" aria-label="Close" class="close" @click.prevent="hideModal()">
                <span class="icon icon-close_small"></span>
            </button>
        </template>

        <div slot="modal-footer" class="w-100">
            <div class="row">
                <div class="col-6  col-lg-6">
                    <b-button @click.prevent="hideModal()"
                            variant="secondary"
                            size="lg"
                            class="custom"
                            block>
                        {{$t('Anuluj')}}
                    </b-button>

                </div>
                <div class="col-6  col-lg-6">
                    <b-button
                            variant="danger"
                            size="lg"
                            class="custom"
                            block
                            @click="confirm()">
                        {{$t('Tak')}}
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import EventBus from '@/event-bus.js'

export default {
  name: 'confrimCancelModal',
  data () {
    return {
      returnPath: 'home'
    }
  },
  methods: {
    showModal () {
      if (this.checkModal() === false) {
        return
      }
      this.$refs.confrimCancelModal.show()
    },
    hideModal () {
      if (this.checkModal() === false) {
        return
      }
      this.$refs.confrimCancelModal.hide()
    },
    checkModal () {
      if (this.$refs == null || this.$refs.length < 1) {
        return false
      }
      if (undefined === this.$refs.confrimCancelModal || this.$refs.confrimCancelModal === null) {
        return false
      }
      return true
    },
    reset () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    confirm () {
      this.$router.push({ name: this.returnPath })
    }
  },
  created () {
    EventBus.$on('SHOW_CONFIRM_CANCEL_MODAL', (data = null) => {
      this.reset()
      if (data.returnPath !== undefined && data.returnPath !== null) {
        this.returnPath = data.returnPath
      }
      this.showModal()
    })
  }
}
</script>

<style scoped>

</style>
